import { render, staticRenderFns } from "./OurBranches.vue?vue&type=template&id=8a53011e&scoped=true"
import script from "./OurBranches.vue?vue&type=script&lang=js"
export * from "./OurBranches.vue?vue&type=script&lang=js"
import style0 from "./OurBranches.vue?vue&type=style&index=0&id=8a53011e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a53011e",
  null
  
)

export default component.exports